import { render } from "./jiezhi_data.vue?vue&type=template&id=1f6c4c3f&scoped=true"
import script from "./jiezhi_data.vue?vue&type=script&lang=js"
export * from "./jiezhi_data.vue?vue&type=script&lang=js"

import "./jiezhi_data.vue?vue&type=style&index=0&id=1f6c4c3f&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f6c4c3f"]])

export default __exports__